import fetch from '@/utils/fetch'
import { IncomingMessage } from 'http'

export interface NewUserCouponsReq {
  countryCode: string
  currencyCode?: string
  language: string
  marketingType: number
  uniqueMark: string
}

export interface NewUserCouponsRes {
  data: {
    couponTemplateList: {
      [key: string]: any
    }[]
    marketingId: number
    // 1可领；2 已领完；3 已领取; 4 已过期。(ps:未登录，默认可领)
    state: 1 | 2 | 3 | 4
    currentTime: number // 当前时间戳
    expireTime: number // 过期时间戳
  }
}

export interface ReceiveCouponRes {
  data: {
    receiveFlag: boolean
  }
  msg: string
}

// 新人领券
export const getNewUserCoupons = (
  body: NewUserCouponsReq,
  headers: any = {},
  req?: IncomingMessage
): Promise<any> =>
  fetch.post({
    url: '/api/v1/h5/adapter/coupon/oversea/couponH5List',
    headers,
    data: body,
    req,
  })

export const receiveCoupon = (
  body: NewUserCouponsReq,
  headers: any = { duToken: 'd41d8cd9|1000001429|1622007394|2ef9238b4bc1d34b' },
  req?: IncomingMessage
): Promise<any> =>
  fetch.post({ url: '/api/v1/h5/adapter/coupon/oversea/receivecoupon', data: body, headers, req })
